import styled from 'styled-components';
import { useScene } from '../../../hooks';
import { LauncherStates } from '../../../types/launcher';
import { IconButton } from '../../generic/IconButton';

const Container = styled.div`
  display: flex;
  padding: 2px;

  border-radius: 10px;
  background-color: var(--panel-bg-color);
`;

const Item = styled.div`
  width: 45px;
  height: 45px;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Separator = styled.div`
  width: 9px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;

  opacity: 0.5;

  &::after {
    content: '';
    width: 1px;
    height: 33px;
    background-color: var(--text-color);
  }
`;

export const StatebarButtons = () => {
  const scene = useScene();
  const launcherStates = scene.launcherStates;

  const toggleLauncherState = (key: string) => {
    const states = scene.launcherStates;
    const prevState = states[key as keyof LauncherStates];

    // Installed | Need Repair | Update Available
    if (
      key === 'isAppInstalled' ||
      key === 'doesAppNeedRepair' ||
      key === 'isAppUpdateAvailable'
    ) {
      states.isAppInstalled = false;
      states.doesAppNeedRepair = false;
      states.isAppUpdateAvailable = false;

      states[key] = !prevState;
    }

    if (key === 'doesAppNeedRepair' || key === 'isAppUpdateAvailable') {
      states.isAppInstalled = true;

      states.doesAppNeedRepair = false;
      states.isAppUpdateAvailable = false;

      states[key] = !prevState;
    }

    // Ongoing Task
    if (
      key === 'doesAppOngoingTaskExist' ||
      key === 'doesAppOngoingInstallTaskExist' ||
      key === 'doesAppOngoingUpdateTaskExist' ||
      key === 'doesAppOngoingUninstallTaskExist' ||
      key === 'doesAppOngoingRepairTaskExist' ||
      key === 'doesAppOngoingMoveTaskExist'
    ) {
      states.doesAppOngoingTaskExist = true;

      states.doesAppOngoingInstallTaskExist = false;
      states.doesAppOngoingUpdateTaskExist = false;
      states.doesAppOngoingUninstallTaskExist = false;
      states.doesAppOngoingRepairTaskExist = false;
      states.doesAppOngoingMoveTaskExist = false;

      states[key] = !prevState;
    }

    if (
      key !== 'doesAppOngoingTaskExist' &&
      states.doesAppOngoingInstallTaskExist === false &&
      states.doesAppOngoingUpdateTaskExist === false &&
      states.doesAppOngoingUninstallTaskExist === false &&
      states.doesAppOngoingRepairTaskExist === false &&
      states.doesAppOngoingMoveTaskExist === false
    ) {
      states.doesAppOngoingTaskExist = false;
    }

    // -----------
    if (key === 'doesAppDirExist' || key === 'doesAppLastTaskFailed') {
      states[key] = !prevState;
    }

    scene.setLauncherStates({ ...states });
  };

  return (
    <Container>
      {/* <Item id="state-doesAppDirExist-icon">
        <IconButton
          isActive={launcherStates.doesAppDirExist}
          handleClick={() => toggleLauncherState('doesAppDirExist')}
        >
          <i className="icon-dir" />
        </IconButton>
      </Item>

      <Separator /> */}

      <Item id="state-isAppInstalled-icon">
        <IconButton
          isActive={launcherStates.isAppInstalled}
          handleClick={() => toggleLauncherState('isAppInstalled')}
        >
          <i className="icon-state-installed" />
        </IconButton>
      </Item>

      <Item id="state-doesAppNeedRepair-icon">
        <IconButton
          isActive={launcherStates.doesAppNeedRepair}
          handleClick={() => toggleLauncherState('doesAppNeedRepair')}
        >
          <i className="icon-state-need-repair" />
        </IconButton>
      </Item>

      <Item id="state-isAppUpdateAvailable-icon">
        <IconButton
          isActive={launcherStates.isAppUpdateAvailable}
          handleClick={() => toggleLauncherState('isAppUpdateAvailable')}
        >
          <i className="icon-state-update-available" />
        </IconButton>
      </Item>

      <Separator />

      <Item id="state-doesAppOngoingTaskExist-icon">
        <IconButton
          isActive={launcherStates.doesAppOngoingTaskExist}
          handleClick={() => toggleLauncherState('doesAppOngoingTaskExist')}
        >
          <i style={{ fontSize: 32 }} className="icon-state-any-task" />
        </IconButton>
      </Item>

      <Item id="state-doesAppOngoingInstallTaskExist-icon">
        <IconButton
          isActive={launcherStates.doesAppOngoingInstallTaskExist}
          handleClick={() =>
            toggleLauncherState('doesAppOngoingInstallTaskExist')
          }
        >
          <i style={{ fontSize: 32 }} className="icon-state-install-task" />
        </IconButton>
      </Item>

      <Item id="state-doesAppOngoingUpdateTaskExist-icon">
        <IconButton
          isActive={launcherStates.doesAppOngoingUpdateTaskExist}
          handleClick={() =>
            toggleLauncherState('doesAppOngoingUpdateTaskExist')
          }
        >
          <i style={{ fontSize: 32 }} className="icon-state-update-task" />
        </IconButton>
      </Item>

      <Item id="state-doesAppOngoingUninstallTaskExist-icon">
        <IconButton
          isActive={launcherStates.doesAppOngoingUninstallTaskExist}
          handleClick={() =>
            toggleLauncherState('doesAppOngoingUninstallTaskExist')
          }
        >
          <i style={{ fontSize: 32 }} className="icon-state-uninstall-task" />
        </IconButton>
      </Item>

      <Item id="state-doesAppOngoingRepairTaskExist-icon">
        <IconButton
          isActive={launcherStates.doesAppOngoingRepairTaskExist}
          handleClick={() =>
            toggleLauncherState('doesAppOngoingRepairTaskExist')
          }
        >
          <i style={{ fontSize: 32 }} className="icon-state-repair-task" />
        </IconButton>
      </Item>

      {/* <Item id="state-doesAppOngoingMoveTaskExist-icon">
        <IconButton
          isActive={launcherStates.doesAppOngoingMoveTaskExist}
          handleClick={() => toggleLauncherState('doesAppOngoingMoveTaskExist')}
        >
          <i style={{ fontSize: 32 }} className="icon-state-move-task" />
        </IconButton>
      </Item> */}

      {/* <Separator />

      <Item id="state-doesAppLastTaskFailed-icon">
        <IconButton
          isActive={launcherStates.doesAppLastTaskFailed}
          handleClick={() => toggleLauncherState('doesAppLastTaskFailed')}
        >
          <i className="icon-state-last-task-failed" />
        </IconButton>
      </Item> */}
    </Container>
  );
};
